import { useState, useEffect } from "react";

// Tailwind's `lg`. Below it, a 260px sidebar takes a quarter to two thirds of
// the window, which is what left the dashboards a 115px content column on a
// phone.
const NARROW_BREAKPOINT = 1024;

/**
 * True while the viewport is too narrow to give a persistent 260px sidebar its
 * width. Callers render an icon rail instead, and open the expanded sidebar
 * over the content.
 *
 * Deliberately not a shadcn-style `useIsMobile`: a 768px breakpoint marks
 * "phone" rather than "cannot afford a sidebar", which is the question callers
 * here are actually asking.
 */
export function useIsNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(
    () =>
      typeof window !== "undefined" && window.innerWidth < NARROW_BREAKPOINT
  );

  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${NARROW_BREAKPOINT - 1}px)`);
    const onChange = () => setIsNarrow(query.matches);
    onChange();
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isNarrow;
}
